<template>
  <b-col md="12">
    <section class="info" v-if="hotel.description.important_information">
      <p class="info__title">Da sapere prima di partire</p>
      <div class="info__wrap">
        <span v-html="hotel.description.important_information.it.replaceAll('.', '.<br>')" />
        <div class="info__license" v-if="license_numbers.length">
          <span class="info__license-title">Numero di licenza:</span>
          <span
            class="info__license-number"
            v-for="(license, license_index) in visible_licenses"
            :key="_uid+license_index"
          >
            {{ license }}
          </span>
        </div>
        <span
          v-if="license_numbers.length > 5"
          v-b-modal="'modal_license'"
          class="info__license-number-more"
        >
          vedi tutte
        </span>
        <vb-modal
          :vb_options="{
            id: 'modal_license',
            title: 'Numeri di licenza',
            size: 'md',
            centered: true,
            hide_footer: true
          }"
        >
          <div v-for="(license, license_index) in license_numbers" :key="_uid+license_index">
            <span>{{ license }}</span>
          </div>
        </vb-modal>
      </div>
      <key-info class="info__key" :hotel="hotel" />
    </section>
  </b-col>
</template>

<script>
import KeyInfo from '@bookingv3/components/blocks/key-info'

export default {
  name: 'info',

  components: {
    'key-info': KeyInfo,
  },

  props: {
    hotel: Object
  },

  data() {
    return {
    }
  },

  computed: {
    license_numbers() {
      return this.hotel.description.license_numbers || []
    },
    visible_licenses() {
      return this.license_numbers.slice(0, 3)
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .info {
    margin-top: $grid-gutter-width*2;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 20px;
    }

    &__wrap {
      background-color: $white;
      padding: 20px;
      border-radius: 10px;
      line-height: $font-size-base * 2;
    }

    &__license {
      font-size: $font-size-md;
      margin-top: 5px;

      &-title {
        font-weight: $vb-font-weight-semibold;
        margin-right: 5px;
      }

      &-number {
        margin-right: $grid-gutter-width / 6;

        &-more {
          color: $info;
          cursor: pointer;
          text-decoration: underline;
          font-size: $font-size-md;
        }
      }
    }

    &__key {
      @extend .info__wrap;
      margin-top: $grid-gutter-width;
    }
  }

</style>